import type { CarouselBiggestType } from '@/types';
import { useLingui } from '@lingui/react';
import { AspectRatio, Group, Image, NumberFormatter, Stack, Text, useMatches } from '@mantine/core';
import { PlayNowButton } from './PlayNowButton';
export const BiggestCard: React.FC<CarouselBiggestType> = ({
  id,
  imgCard,
  won,
  date
}) => {
  const {
    i18n
  } = useLingui();
  const ratio = useMatches({
    base: 128 / 136,
    lg: 148 / 157
  });
  return <Stack gap={4} pr={{
    base: 0,
    sm: 8
  }} style={{
    cursor: 'pointer'
  }}>
      <AspectRatio ratio={ratio}>
        <Image src={imgCard} alt={`biggest-card-${id}`} />
      </AspectRatio>

      <Group justify="space-between" wrap="nowrap" mt={8}>
        <Text tt="uppercase" fw={700} fz={{
        base: 10,
        sm: 12
      }} c="var(--text-dark)">
          {i18n._('Won')}
        </Text>
        <Text fw={700} fz="xs" c="var(--text-green)">
          <NumberFormatter value={won} thousandSeparator="," prefix="$" />
        </Text>
      </Group>

      <Group justify="space-between" wrap="nowrap" mb={8}>
        <Text tt="uppercase" fw={700} fz={{
        base: 10,
        sm: 12
      }} c="var(--text-dark)">
          {i18n._('Date')}
        </Text>
        <Text fw={500} fz="xs" c="var(--text-dark)">
          {date}
        </Text>
      </Group>

      <PlayNowButton />
    </Stack>;
};